// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/basic.css
// module id = JEDg
// module chunks = 1 2 3